import clipboardBuilder from '../../shared/clipboard_builder.coffee'

$(->
  clipboardBuilder.build('.copy_careers_page_button')

  # See issue on https://github.com/twbs/bootstrap/issues/16732
  # Popover takes two clicks to open after manual 'hide'
  $('body').on 'hidden.bs.popover', (e) ->
    $(e.target).data("bs.popover").inState.click = false;
)
